import axios from 'axios'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { formatISO } from "date-fns";

const initialState = {
  data: [],
  status: 'idle',
  errors: null,
  last_refresh: null,
  api_tries: 0
}

export const fetchPortfolios = createAsyncThunk(
  'portfolio/fetchPortfolios',
  async (accessToken) => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_DOMAIN}/portfolio`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )
    return response.data.data
  }
)

export const portfolioSlice = createSlice({
  name: 'portfolios',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchPortfolios.pending, (state, action) => {
        state.status = 'loading'
      })
      .addCase(fetchPortfolios.fulfilled, (state, action) => {
        action.payload.unshift({ id: null, name: 'All Portfolios' })
        state.status = 'succeeded'
        state.data = action.payload
        state.last_refresh = formatISO(new Date())
        state.api_tries = 0
      })
      .addCase(fetchPortfolios.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
        state.api_tries += 1
      })
  },
})

export const selectPortfolios = (state) => state.portfolios

export default portfolioSlice.reducer
